import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';

import { CustomTable } from '../../../shared/uiComponents';
import { HeadersBT, TableBody } from './tableInfo';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getAvailableClientBTs } from '../../../redux/State/clientSlice/userClientSlice';

const BT = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params, setParams] = useSearchParams();
	const { clientId } = useParams();

	const bts = useSelector((state) => state.userClient.availableBTs);
	const loading = useSelector((state) => state.userClient.loadingGetAvailableBTs);

	useEffect(() => {
		if (!clientId) return;
		params.delete('credentialed');
		setParams(params, { replace: true });
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const orderBy = params.get('orderBy') || '';
		const direction = params.get('direction') || '';
		const searchString = params.get('search') || '';
		const status = params.get('status') || '';

		dispatch(
			getAvailableClientBTs({
				clientId,
				page,
				pageSize,
				orderBy,
				direction,
				searchString,
				status,
			}),
		);
	}, [params, setParams, clientId, dispatch]);

	return <CustomTable headers={HeadersBT} data={bts} TableBody={TableBody} loading={loading} hasMobile={false} />;
};

export default BT;
